.rootWithChildren {
  display: grid;
  grid-template-columns: 100px 100px;
  grid-template-rows: auto;
  align-items: center;
  justify-content: space-around;
  row-gap: 23px;
  .item {
    width: 100px;
    text-align: center;
    text-decoration: none;
    transition: 0.3s ease all;

    .thumbnail {
      width: 100px;
      height: 100px;
      background-color: #ecebea;
      border-radius: 50%;
    }
    .title {
      margin-top: 5px;
      text-align: center;
      font-family: Copperplate;
      font-size: 14px;
      font-weight: lighter;
      font-weight: 400;
      line-height: 14px;
      letter-spacing: 0em;
      text-align: center;
      color: #161a21;
      text-transform: uppercase;
    }
    &:hover {
      transform: translateY(-2px);
    }
  }
}
.rootWithoutChildren {
  display: grid;

  grid-template-rows: auto auto auto;
  row-gap: 30px;
  .thumbnail {
    background-color: #ecebea;
    // background-color: #f8f7f4;
  }
  .content {
    .title {
      font-family: Montserrat;
      font-size: 14px;
      font-style: normal;
      font-weight: 400;
      line-height: 20px;
      letter-spacing: 0.02em;
      text-align: center;
    }
    .subtitle {
      font-family: Montserrat;
      font-size: 14px;
      font-style: normal;
      font-weight: 600;
      line-height: 20px;
      letter-spacing: 0.02em;
      text-align: center;
      color: #ff5e57;
    }
    .description {
      font-family: Montserrat;
      font-size: 14px;
      font-style: normal;
      font-weight: 400;
      line-height: 20px;
      letter-spacing: 0.02em;
      text-align: center;
    }
  }
  .footer {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    .ctaButton {
      font-family: Montserrat;
      font-size: 14px;
      font-style: normal;
      font-weight: 700;
      letter-spacing: -0.02em;
      text-align: center;
      background: #161a21;
      padding: 12px 36px;
      text-decoration: none;
      color: #fff;
      display: inline-block;
      text-transform: uppercase;
    }
  }
}
